import { render, staticRenderFns } from "./ParallaxVideoStyle.vue?vue&type=template&id=5304c3c0"
import script from "./ParallaxVideoStyle.vue?vue&type=script&lang=js"
export * from "./ParallaxVideoStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports